import { createFileRoute } from '@tanstack/react-router';

import { automaticSplitFormScreen, automaticSplitFormSearch, loadAutomaticSplitMessages, loadAutomaticSplitScreens } from '@/modules/automatic-split/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Criar (`nova`) e editar a operação (`router.tsx:664-668`).
export const Route = createFileRoute('/_app/contas-digitais/split-automatico/$operationId/detalhes')({
  validateSearch: automaticSplitFormSearch,
  staticData: { screen: automaticSplitFormScreen },
  loader: () => loadAutomaticSplitMessages(),
  component: lazyScreen(loadAutomaticSplitScreens, 'AutomaticSplitFormRouteScreen'),
});
